import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    accountCreated: false,
    email: "",
    error: false,
    errorPhrase: ""
}

const signUpSlice = createSlice({
    name: "signUp",
    initialState,
    reducers: {
        accountCreated: (state,action) => {
            state.accountCreated = true
            state.email = action.payload.email
        },
        accountCreationError: (state,action) => {
            state.error = true
            state.errorPhrase = action.payload.errorPhrase
        },
        reset: state => initialState,
    },
})

export const { accountCreated, accountCreationError, reset } = signUpSlice.actions
export default signUpSlice.reducer